import React, { ReactElement, useEffect, useState } from 'react';
import { Menu, MenuItem, ProSidebar, SidebarFooter } from 'react-pro-sidebar';
import { Avatar, Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import 'react-pro-sidebar/dist/css/styles.css';
import HomeIcon from '@mui/icons-material/Home';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import ListAltIcon from '@mui/icons-material/ListAlt';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import { makeStyles } from '@mui/styles';
import { useLocation } from 'react-router-dom';
import { colors, theme } from '../../../theme';
import { msalInstance } from '../../../config/msalConfig';

const color = colors();
export const SideNavMenu = (): ReactElement => {
	const classes = useStyles();
	const themes = theme().typography;

	const location = useLocation();
	const pathSegments = location.pathname.split('/').filter(Boolean);
	const routeName = pathSegments[pathSegments.length - 1];

	const [isCollapsed, setIsCollapsed] = useState(true);
	const [selected, setSelected] = useState(routeName ? `/${routeName}` : '/');
	const loggedInUser: string = msalInstance.getActiveAccount()?.name?.split('(')[0] || '';

	const stringAvatar = (name: string) => {
		return {
			children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
		};
	};

	const Item = ({ title, to, icon, selected, setSelected, className }: any) => (
		<MenuItem
			active={selected === to}
			onClick={() => setSelected(to)}
			icon={icon}
			className={`${classes.menuItem} ${className || ''}`}
		>
			<Typography {...themes.bodyRegular}>{title}</Typography>
			<Link to={to} />
		</MenuItem>
	);

	useEffect(() => {
		setSelected(routeName ? `/${routeName}` : '/');
	}, [location]); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<Box className={classes.sideNavMenu}>
			<ProSidebar collapsed={isCollapsed}>
				<Menu>
					<MenuItem onClick={() => setIsCollapsed(!isCollapsed)} icon={<MenuOutlinedIcon />}>
						{!isCollapsed && (
							<Box display="flex">
								<Typography variant="h5" className={classes.menuTitle}>
									TraceTracker
								</Typography>
							</Box>
						)}
					</MenuItem>
					<Item title="Home" to="/" icon={<HomeIcon />} selected={selected} setSelected={setSelected} />
					{/* <Item
						title="Material"
						to="/material"
						icon={<img alt="material" src={require('../../../images/material.png')} className={classes.materialIcon} />}
						selected={selected}
						setSelected={setSelected}
					/> */}
					<Item
						title="Material Integrity"
						to="/ruleengine"
						icon={<ListAltIcon />}
						selected={selected}
						setSelected={setSelected}
					/>
					{localStorage.getItem('isSupplierAccount') !== 'true' && (
						<Item
							title="External Traceability"
							to="/supplier"
							icon={<HubOutlinedIcon />}
							selected={selected}
							setSelected={setSelected}
						/>
					)}
					<Item
						title="Brand Certificates"
						to="/brandCertification"
						icon={<WorkspacePremiumIcon />}
						selected={selected}
						setSelected={setSelected}
					/>
					{/* <Item
						title="Go to PowerBI"
						to="/powerbi"
						icon={<img alt="powerbi" src={require('../../../images/power-bi.png')} className={classes.pngIcon} />}
						selected={selected}
						setSelected={setSelected}
						className={classes.powerbi}
					/> */}
				</Menu>
				<SidebarFooter>
					{!isCollapsed && (
						<Typography className={classes.footerText}>
							For any questions regarding TT, or if you would like to be added to the email notification distribution list for newly added materials, please contact:
						</Typography>
					)}
					{!isCollapsed && (
						<Typography className={classes.footerText}>
							<a href="mailto:dlfibertoproducttraceabilityflow.all@hm.com">dlfibertoproducttraceabilityflow.all@hm.com</a>
						</Typography>
					)}
					{
						<Menu>
							<Item
								title={loggedInUser}
								to="/user"
								
								icon={<Avatar {...stringAvatar(loggedInUser)} className={classes.footerItem} />}
								selected={selected}
								setSelected={setSelected}
							/>
						</Menu>
					}
				</SidebarFooter>
			</ProSidebar>
		</Box>
	);
};

const useStyles = makeStyles({
	sideNavMenu: {
		backgroundColor: color.shades.white,
		color: color.shades.white,
		'& .pro-sidebar': {
			width: '260px',
			minWidth: '260px',
		},
		'& .pro-sidebar-inner': {
			backgroundColor: `${color.primary.logoDark} !important`,
		},
		'& .pro-sidebar .pro-menu': {
			padding: '0px',
		},
		'& .pro-sidebar.collapsed': {
			width: '55px',
			minWidth: '55px',
		},
		'& .pro-sidebar-layout': {
			overflow: 'hidden !important',
		},
		'& .pro-menu-item.active': {
			color: `${color.primary.logoLight} !important`,
			backgroundColor: color.primary.logoDark,
			borderLeft: `5px solid ${color.primary.logoLight}`,
		},
		'& .pro-inner-item': {
			padding: '8px 16px !important',
			gap: '10px',
		},
		'& .pro-inner-item:hover': {
			color: `${color.primary.logoLight} !important`,
		},
		'& .pro-sidebar.collapsed .pro-inner-item': {
			padding: '8px 5px !important',
		},
		'& .pro-sidebar-footer': {
			height: '155px',
			position: 'absolute',
			bottom: 0,
			left: 0,
			right: 0,
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'flex-end',
		},
		'& .pro-icon': {
			color: color.shades.white,
		},
		'& .pro-icon-wrapper': {
			color: color.shades.white,
			margin: '0px !important',
		},
	},
	menuTitle: {
		fontWeight: '600 !important',
		fontSize: '20px !important',
		lineHeight: '32px !important',
		color: color.shades.white,
	},
	menuItem: {
		color: color.shades.white,
	},
	footerItem: {
		backgroundColor: `${color.shades.white} !important`,
		color: `${color.primary[100]} !important`,
		fontSize: '12px !important',
		width: '24px !important',
		height: '24px !important',
	},
	footerText: {
		color: color.shades.white,
		fontSize: '12px !important',
		lineHeight: '16px',
		padding: '0px 10px 0px 10px',
		opacity: 0.8,
		'& a': {
			color: color.primary.logoLight,
		},
	},
	pngIcon: {
		width: '20px',
		height: '20px',
	},
	materialIcon: {
		width: '34px',
		height: '34px',
	},
	powerbi: {
		position: 'absolute !important' as any,
		bottom: '50px',
		width: '100%',
	},
});
